const SHELLY_COTURN: RTCIceServer[] = [
	{
		urls: 'turn:turn.shelly.cloud:3478',
		username: 'admin2',
		credential: 'admin2',
	},
	{
		urls: 'stun:stun.shelly.cloud:3478',
	},
];

export const RTC_CONFIGURATION: RTCConfiguration = {
	iceServers: [...SHELLY_COTURN],
	bundlePolicy: 'max-bundle',
};
export const MAX_POLLS = 10;
export const POLL_DELAY_MS = 350;

/**
 * Supported WebRTC negotiation strategies:
 * - `'GetAnswer'`    — client builds the offer locally and calls
 *                      `Streamer.GetAnswer` to fetch the camera's answer.
 * - `'OfferRequest'` — client calls `streamer.Offer`, the camera returns its
 *                      offer SDP, the client sends back its answer via
 *                      `streamer.Answer`. ICE candidates are optionally
 *                      trickled via `streamer.Trickle` / `streamer.Poll`
 *                      when the offer frame does not include
 *                      `end_of_candidates`.
 */
export type NegotiationStrategy = 'GetAnswer' | 'OfferRequest';

export const NEGOTIATION_STRATEGY: NegotiationStrategy = 'GetAnswer';

export const ICE_GATHERING_TIMEOUT_MS = 2_000;

/**
 * How long the UI waits for the camera to confirm a push-to-talk state change
 * (via the `ptt` data channel) before giving up and forcing the local state
 * to the user's last intent.
 */
export const TALK_CONFIRMATION_TIMEOUT_MS = 10_000;

/**
 * Marker in a `start_error` raised by `sendCamRPC` before the cloud socket is
 * up. It is a transient startup condition rather than a stream failure, so it
 * is retried without surfacing an error to the user.
 */
export const AWAITING_CLOUD_MESSAGE = 'Awaiting cloud connection';

/** Delay before retrying negotiation that failed to reach the camera. */
export const CLOUD_RETRY_DELAY_MS = 1_000;

/** Delay before rebuilding a connection whose ICE transport dropped. */
export const DISCONNECTED_RETRY_DELAY_MS = 100;

/** Delay before retrying a connection that negotiated but carried no media. */
export const STREAM_RETRY_DELAY_MS = 5_000;

/**
 * How long a shared session stays alive after its last consumer is released.
 * Screen switches (drawer to sidepanel, tab changes) unmount one player and
 * mount another within this window, so the connection is reused instead of
 * renegotiated. Cameras allow only 3 simultaneous streams, so this must stay
 * short.
 */
export const SESSION_LINGER_MS = 5_000;

/**
 * Delay before a session suspended by `beforeunload` / `pagehide` reconnects.
 * Neither event means the page is certainly gone — the user can cancel the
 * navigation, and mobile fires `pagehide` for app switches and bfcache — so the
 * reconnect is scheduled rather than assumed unnecessary. When the page really
 * does go away the timer dies with it.
 */
export const UNLOAD_RESUME_DELAY_MS = 250;
